import { render, staticRenderFns } from "./SettingsColor.vue?vue&type=template&id=7c59472e&"
import script from "./SettingsColor.vue?vue&type=script&lang=js&"
export * from "./SettingsColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports